import { CASHFLOW_FROM_BANKING } from '../Financials/constants';

export const CFB_UNIT_STORAGE_KEY = 'aica.cfb.unit';

export const BANK_STATEMENTS = 'bankStatements';

export const BANKING_OVERVIEW_LABEL = 'Banking Overview';
export const BACK_TO_BANKING_OVERVIEW_LABEL = `Back to ${BANKING_OVERVIEW_LABEL}`;

export const CFB_OPENED_SOURCES = {
    PILL: 'banking',
    LINK: 'link',
    REVISIT: 'revisit',
} as const;

export const CFB_FILTER_TYPES = {
    QUICK_RANGE: 'quickRange',
    CUSTOM_START_DATE: 'customStartDate',
    CUSTOM_END_DATE: 'customEndDate',
    UNIT: 'unit',
} as const;

export const CFB_FILTER_LOCATIONS = {
    PAGE: 'page',
    DRAWER: 'drawer',
} as const;

// Must match the server's max window in InsightsFinanceService.
export const BANK_RANGE_MAX_MONTHS = 120;

// Quick-range options on the Banking "Time Period" control.
export const QUICK_RANGE_KEYS = {
    LAST_FY: 'LAST_FY',
    LAST_12M: 'LAST_12M',
    CURRENT_FY: 'CURRENT_FY',
} as const;

// Quick-range options for the CFB/drill-down Time Period control, in design order.
export const CFB_QUICK_RANGES = [
    { id: QUICK_RANGE_KEYS.LAST_12M, label: 'Last 12 M' },
    { id: QUICK_RANGE_KEYS.LAST_FY, label: 'Last FY' },
    { id: QUICK_RANGE_KEYS.CURRENT_FY, label: 'Current FY' },
] as const;

/** Toolbar width below which the CFB quick ranges fold into the overflow menu. */
const HEADER_SIDE_PADDING_PX = 24;
const headerContentWidth = (outerWidth: number) => outerWidth - 2 * HEADER_SIDE_PADDING_PX;

export const CFB_INLINE_RANGES_MIN_WIDTH = headerContentWidth(1000);

/** Header row width below which Excel Analysis folds into a ⋮ menu (with/without the account dropdown). */
export const BANK_STATEMENTS_HEADER_MIN_WIDTH = headerContentWidth(900);
export const BANK_STATEMENTS_HEADER_MIN_WIDTH_WITH_ACCOUNT = headerContentWidth(1150);
export const BANK_STATEMENTS_HEADER_MIN_WIDTH_WITH_BACK_LABEL = headerContentWidth(820);

export const ACCOUNT_SWITCH_LOADING_MS = 300;

export const BANK_STATEMENTS_HEADER_HEIGHT_VAR = '--bank-statements-header-height';
export const BANK_STATEMENTS_ORB_CLEARANCE_VAR = '--bank-statements-orb-clearance';
export const ASK_AICA_ORB_OFFSET_VAR = '--ask-aica-orb-offset';
export const ASK_AICA_ORB_HEIGHT_VAR = '--ask-aica-orb-height';
export const ASK_AICA_ORB_GAP_VAR = '--ask-aica-orb-gap';

export const BANKING_TYPES = [
    { id: BANK_STATEMENTS, label: 'Bank Statements' },
    { id: CASHFLOW_FROM_BANKING, label: 'Cashflow From Banking' },
];
